import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/capacity")({
  staticData: { pageTitle: "breadcrumbs.capacity" },
  component: CapacityLayout,
});

function CapacityLayout() {
  return <Outlet />;
}
